import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=c309dcf6&shadow"
import script from "./Checkbox.vue?vue&type=script&lang=js&shadow"
export * from "./Checkbox.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports